const FEATURE_FLAGS = {
  PROPOSALS: "proposals",
  SUPPLIER_INFO: "pwa_enable_supplier_info",
};

export default FEATURE_FLAGS;
